const ADG_PREFIX = "/roomplanner";

export const getAdgReadyUrl = (config, url: string) => {
	const isAdgEnabled = config && config.urls && !!config.urls.adgUrlPrefix;

	if (!isAdgEnabled) {
		return url;
	}

	if (url.startsWith(ADG_PREFIX)) {
		return url;
	}

	return `${ADG_PREFIX}${url.startsWith("/") ? "" : "/"}${url}`;
};
